var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogovPrimarycLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 925.5993,
    height: 149.85199,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 792h792V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -65.199997 602.92584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-30.639-15.688 18.81-28.898 46.585 71.573H-58.415l8.483-13.032c.115-.169.223-.343.325-.519.738-1.276 1.162-2.756 1.162-4.335 0-4.786-3.882-8.667-8.668-8.667-3.466 0-6.456 2.036-7.843 4.975l-14.611 22.448c-.507.78-.99 1.46-1.427 2.289-.64 1.304-1 2.772-1 4.324 0 5.228 4.082 9.501 9.234 9.807l.593.019H48.48c.551 0 .818-.019 1.364-.095 4.782-.662 8.464-4.766 8.464-9.731 0-1.338-.268-2.614-.751-3.775-.27-.646-.655-1.244-1.005-1.849L-2.822-62.377c-.509-.78-.961-1.521-1.556-2.228-1.802-2.132-4.497-3.488-7.509-3.488-1.545 0-2.988.37-4.272 1.017-1.966.989-3.269 2.607-4.6 4.58l-28.674 44.057c-.39.597-.865 1.289-1.206 1.909-.681 1.236-1.068 2.659-1.068 4.171 0 2.852 1.377 5.381 3.503 6.961 1.054.781 3.969 2.112 5.148 2.715L-9.808 14.34c1.536.787 3.103 1.676 4.639 2.424 1.101.538 2.399 1.004 3.953 1.004 4.787 0 8.667-3.881 8.667-8.667 0-2.534-1.088-4.814-2.822-6.398C3.355 1.539 1.545.791 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(130.894 407.8984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v10.573h-5.593v-56.706H0v27.504C0-9.487 1.928-2.92 5.745 1.087c3.818 4.008 8.972 5.65 15.46 4.886v5.269c-5.114.668-9.485-.02-13.111-2.081C4.448 7.118 1.756 4.065 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(721.8945 409.9536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.643 0 12.159 1.546 16.548 4.638 4.41 3.092 7.749 7.006 10.021 11.738l-5.421 1.623c-1.602-3.568-4.256-6.586-7.939-9.028C9.505 6.527 5.116 5.307 0 5.307c-6.891 0-12.502 2.061-16.796 6.184-4.313 4.122-6.604 9.563-6.91 16.357h50.6c.076.936.114 2.08.114 3.455 0 8.092-2.481 14.81-7.462 20.136-4.983 5.325-11.816 7.998-20.5 7.998-8.379 0-15.232-2.825-20.537-8.475-5.325-5.649-7.98-12.692-7.98-21.168 0-9.009 2.769-16.242 8.284-21.663C-15.67 2.711-8.608 0 0 0m-23.706 32.867c.382 5.975 2.672 11.013 6.91 15.136 4.237 4.123 9.505 6.184 15.842 6.184 6.642 0 11.911-1.927 15.822-5.801 3.932-3.857 6.109-8.991 6.549-15.404z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(681.2002 362.4268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v5.267h-20.919v20.118h-5.649V5.267h-12.025V0h12.025v-35.273c0-5.306 1.315-9.449 3.912-12.445 2.615-2.997 6.469-4.505 11.586-4.505 3.569 0 7.271.802 11.07 2.406l-1.68 5.249c-2.978-1.451-5.936-2.177-8.838-2.177-6.927 0-10.401 3.819-10.401 11.472V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(648.4844 415.2598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-28.745c0-7.12-2.022-12.883-6.089-17.311-4.064-4.41-9.352-6.624-15.823-6.624-5.706 0-10.135 1.738-13.266 5.193-3.129 3.473-4.694 8.34-4.694 14.602V0h-5.593v-33.439c0-7.731 2.08-13.764 6.241-18.114 4.162-4.371 9.735-6.547 16.741-6.547 5.305 0 9.848 1.183 13.685 3.569C-4.98-52.144-2.041-48.976 0-45.026v-11.681h5.594V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(597.1934 420.5269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c8.455 0 15.518 2.843 21.167 8.551 5.631 5.707 8.455 12.789 8.455 21.243 0 8.476-2.824 15.519-8.455 21.168C15.518 56.612 8.455 59.437 0 59.437c-8.589 0-15.709-2.825-21.397-8.475-5.688-5.649-8.533-12.692-8.533-21.168 0-8.454 2.865-15.536 8.552-21.243C-15.671 2.843-8.551 0 0 0m0 5.307c-6.871 0-12.636 2.327-17.293 6.965s-6.986 10.442-6.986 17.39c0 6.946 2.329 12.768 6.986 17.463C-12.636 51.84-6.871 54.187 0 54.187c6.774 0 12.481-2.347 17.101-7.062 4.619-4.695 6.929-10.517 6.929-17.463 0-6.948-2.31-12.752-6.929-17.39C12.481 7.634 6.774 5.307 0 5.307",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(514.7461 362.4268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v10.573h-5.593v-56.706H0v27.504C0-9.487 1.928-2.92 5.744 1.087c3.819 4.008 8.973 5.65 15.461 4.886v5.269c-5.114.668-9.486-.02-13.112-2.081C4.447 7.118 1.756 4.065 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(461.2686 409.9536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.024 0 12.961 1.66 17.827 4.982 4.849 3.321 8.246 7.157 10.136 11.509l-13.648 4.028c-2.671-5.098-7.366-7.656-14.086-7.656-5.02 0-8.971 1.202-11.795 3.608-2.826 2.405-4.503 5.574-5.039 9.525h45.027c.209 1.24.324 3.035.324 5.382 0 8.57-2.673 15.671-8.017 21.32-5.343 5.65-12.655 8.474-21.893 8.474-8.989 0-16.282-2.9-21.892-8.684-5.612-5.802-8.418-13.093-8.418-21.892 0-9.182 2.921-16.568 8.761-22.179C-16.892 2.805-9.313 0 0 0m-16.605 35.5c.458 3.513 2.06 6.529 4.848 9.068 2.767 2.538 6.26 3.798 10.479 3.798 4.371 0 7.902-1.221 10.632-3.684 2.709-2.463 4.255-5.515 4.637-9.182z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(418.2959 362.1982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.118-1.068-4.409-1.622-6.872-1.622-4.732 0-7.099 2.443-7.099 7.328v24.89h16.93v13.246h-16.93v18.802h-15.213V43.842h-9.735V30.596h9.735V5.706c0-6.489 1.623-11.547 4.867-15.211 3.245-3.647 8.054-5.477 14.468-5.477 4.449 0 8.952.915 13.534 2.748z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(380.8018 377.9063)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c8.875 0 16.242 2.92 22.12 8.779 5.861 5.861 8.8 13.132 8.8 21.835 0 8.705-2.919 15.976-8.78 21.817-5.841 5.821-13.247 8.741-22.16 8.741-8.933 0-16.338-2.92-22.198-8.741-5.879-5.841-8.818-13.112-8.818-21.817 0-8.703 2.939-15.974 8.818-21.835C-16.358 2.92-8.953 0 0 0m0 13.762c-4.81 0-8.723 1.584-11.74 4.751-3.014 3.17-4.523 7.196-4.523 12.083 0 4.866 1.509 8.895 4.523 12.063 3.017 3.168 6.93 4.753 11.74 4.753 4.81 0 8.721-1.585 11.719-4.753 2.996-3.168 4.505-7.197 4.505-12.063 0-4.887-1.509-8.913-4.505-12.083C8.721 15.346 4.81 13.762 0 13.762",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(309.4155 362.1982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.787 0-14.01-2.978-18.667-8.951v7.329h-15.098V-59.55h15.098v28.63c0 5.115 1.28 9.18 3.818 12.253 2.557 3.055 5.935 4.582 10.154 4.582 4.065 0 7.138-1.28 9.218-3.838 2.101-2.556 3.151-6.088 3.151-10.592V-59.55h15.135v33.878c0 7.942-1.947 14.22-5.84 18.801C13.074-2.29 7.425 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(249.7744 423.3706)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogovPrimarycLight);
export default __webpack_public_path__ + "static/media/logo.v-primary.c-light.93e9baf7a8df5f983b52460cf619fb91.svg";
export { ForwardRef as ReactComponent };